export type ThemePreference = 'auto' | 'light' | 'dark';
export type ResolvedTheme = 'light' | 'dark';

const CYCLE: ThemePreference[] = ['auto', 'light', 'dark'];

export class Theme {
  readonly preference: ThemePreference;

  private constructor(preference: ThemePreference) {
    this.preference = preference;
  }

  static create({ preference }: { preference: ThemePreference }): Theme {
    return new Theme(preference);
  }

  static fromStored({ stored }: { stored: unknown }): Theme {
    return new Theme(
      CYCLE.includes(stored as ThemePreference) ? (stored as ThemePreference) : 'auto'
    );
  }

  resolve({ systemPrefersDark }: { systemPrefersDark: boolean }): ResolvedTheme {
    if (this.preference !== 'auto') {
      return this.preference;
    }
    return systemPrefersDark ? 'dark' : 'light';
  }

  next(): Theme {
    const index = (CYCLE.indexOf(this.preference) + 1) % CYCLE.length;
    return new Theme(CYCLE[index] as ThemePreference);
  }
}
